import {
  CREDIT_LINE_FETCH_SUCCESS,
  CREDIT_LINE_FETCH_ERROR,
} from '../actionTypes';

let initialState = {
  id: null,
  type: null,
  start_timestamp: null,
  end_timestamp: null,
  client_decision: null,
  convenience_fee_type: null,
  option_terms_rate: [],
}

export default function creditLine(state = initialState, action) {
  switch (action.type) {
    case CREDIT_LINE_FETCH_SUCCESS:
      return { ...state, ...action.payload };
    case CREDIT_LINE_FETCH_ERROR:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/CreditLimit/reducers/creditLine.js